<template>
  <Page :title="title">
    <!-- 顶部筛选栏   输入框  搜索 -->
    <div class="header-titile-all">
      <div class="searchTitle-top-header flex">
        <div class="searchTitle-top">
          <div class="picker-alls"  v-show="PageShow==false"   @click="pickerClient(1)">{{queryFlagText}}
            <div class="triangle_border_down"></div>
          </div>
          <div class="flex input-search-flex"  :style="{flex:PageShow==true?'.95':''}" >
            <input type="text" placeholder="客户姓名/手机号码"   ref="inputText" v-model="queryParam"  class="search_input"  @keyup.enter="submitInput(queryParam)" >
            <img :src="require('@/assets/img/search.png')" class="search-img" alt="" @click="searchInput(queryParam)" >
          </div>
        </div>
        <div class="filtrate-list flex"  @click="searchFilter" >
          <img :src="require('@/assets/img/filtrate.png')" class="filtrate-img" alt="">
          <div>筛选</div>
        </div>
      </div>
      <!-- 筛选列表区域 -->
      <div class="flex  flexJ">
        <div class="filtrate-lists-areaList">
           <van-checkbox v-model="checked"  v-show="PageShow==true"  >
                <img
                slot="icon"
                slot-scope="props"
                :src="props.checked ? Icon[0]: Icon[1]"
                class="radioImg"
                @click="clickCheck(checked)"
              >
           </van-checkbox>
        <div
          class="flex filtrate-lists-area-item"
          v-for="(item,index) in filtrateList"
          v-bind:key="index" @click="order4Page(item)"
        >
          <div :class="item.status!=0?'activeTitle':''">{{item.name}}</div>
          <div class="triangle flexC">
            <div class="triangle_border_up "  :class="item.status==1||item.status==-1?'activeTitles':''"  v-if="item.status == 0 || item.status==1"></div>
            <div class="triangle_border_down " :class="item.status==1||item.status==-1?'activeTitles':''" v-if="item.status == 0 || item.status==-1"></div>
          </div>
         </div>
        </div>
      </div>
    </div>
    <!-- 滑动区域 -->
    <div class="scroll-view"  ref="scrollView">
      <van-list
      v-model="loading"
      :loading="false"
      :finished="finished"
      :immediate-check="false"
      finished-text="没有更多了"
      @load="onLoad"
      ref="page"
    >
        <!-- 内容版块 -->
        <div class="scroll-view-list-item" v-for="(item,index) in list" v-bind:key="index">
          <div class="checkbox-list" v-show="PageShow==true">
             <van-checkbox v-model="item.edit">
              <img
                slot="icon"
                slot-scope="props"
                :src="props.checked ? Icon[0]: Icon[1]"
                class="radioImg"
              >
             </van-checkbox>
          </div>
          <div class="headerImgTop" @click="toClientDetail(item.custId)">
            <img class="headerImg" :src=" item.headImgUrl?item.headImgUrl:item.gender==1?require('@/assets/WW.png'):require('@/assets/MM.png')" alt="">
            <img class="vipImg"   v-if="item.member=='10'" :src="require('@/assets/img/v.png')" alt="">
                                          <div class="VIP-starts"  v-if="item.vipLevel" :style="'width:'+item.vipLevel*.4+'rem'">
                                                <img
                                                      v-for="(item,index) in item.vipLevel"
                                                      v-bind:key="index"
                                                      :src="require('@/assets/img/vipStar.png')"
                                                      class="start"
                                                      alt=""
                                                      srcset=""
                                                >
                                          </div>
          </div>
          <div class="information-list " @click="toClientDetail(item.custId)">
            <div class="information-list-item  item-lists flex activeFont">{{item.custName||''}}
              <img class="sexImg" :src="item.gender==1?require('@/assets/WW1.png'):item.gender==0?require('@/assets/MM1.png'):''" alt="">
            </div>
            <div class="information-list-item activeFont item-lists">
              <img
              :src="require('@/assets/img/phones.png')"
               class="phoneImg"
              alt=""
              srcset=""
                                          >
              {{item.mobile||''}}</div>
            <div class="information-list-item item-lists activeFonts">预计购买日期: {{item.planDate?item.planDate.split(' ')[0]:''}}</div>
            <div class="information-list-item item-lists activeFonts">最近购买日期: {{item.buyDate?item.buyDate.split(' ')[0]:''}}</div>
            <div class="information-list-item item-lists activeFonts">跟进日期: {{item.followDate||''}}</div>
          </div>
          <!-- 快捷操作 -->
          <div class="tool">
                <div class="operation item" v-if="PageShow==false&&showCC==false&&columnK.length>0"                 @click="shortcut(item.custId)">
                <img
                :src="require('@/assets/img/set.png')"
                class="phoneImg"
                alt=""
                srcset=""
                >
                快捷操作
                </div>

            <div class="operation-chat item"    @click="openUserProfile(item.U_UseId)"   v-if="showCC==false && PageShow==false && item.U_UseId!=null">
                <img
                :src="require('@/assets/img/chat.png')"
                class="phoneImg"
                alt=""
                srcset=""
                >
                发起聊天
            </div>
            <div class="operation-chat item"    @click="openTaskUrl(item.U_UseId)" v-if="showCC==false && PageShow==false && item.U_UseId!=null"  >
                查看任务
            </div>
            </div>
        </div>
     </van-list>
    </div>
    <!-- 定位 -->
    <div :class="hasAddAuth ? 'orientation-bottom' : 'orientation-bottom-1'" v-show="PageShow==false&&showCC==false" >
      <!-- 主页 -->
      <div class="homePage" @click="home">
        <img :src="require('@/assets/img/homePage.png')" class="homePageImg" alt="">
      </div>
      <!-- 添加 -->
      <div class="add" @click="addClients" v-if="hasAddAuth">
        <img :src="require('@/assets/img/add.png')" class="addImg" alt="">
      </div>
    </div>
    <!-- 弹出层 新增客户 -->
    <van-popup v-model="addClient">
      <div class="add-model">
        <!-- 标题 -->
        <div class="addClientTitle">新增客户</div>
        <!-- 区号  手机号号码 -->
        <div class="codePhone">
          <div class="codeArea">
            <div class="codeAreaInput"  @click="pickerClient(2)"  >{{addClientObj['code']}}</div>
          </div>
          <div class="input-flex">
            <input type="number"    oninput="if(value.length>30)value=value.slice(0,30)"     @blur="phoneCS(addClientObj['phone'])" v-model="addClientObj['phone']"   placeholder="请输入手机号码">
          </div>
        </div>
        <!-- 请输入客户姓名 -->
        <div class="client-name">
          <div class="client-name-flex">
            <input type="text"  oninput="if(value.length>100)value=value.slice(0,100)"    class="client-name-input"  v-model="addClientObj['name']"   placeholder="请输入客户姓名">
          </div>
        </div>
        <!--  单选项  -->
        <div class="genderRadio-flex">
        <van-radio-group  v-model="addClientObj['sex']">
          <van-radio name="1"> 男
              <img
                slot="icon"
                slot-scope="props"
                :src="props.checked ? Icon[0]: Icon[1]"
                class="radioImg"
              >
          </van-radio>
          <van-radio name="2"> 女
              <img
                slot="icon"
                slot-scope="props"
                :src="props.checked ? Icon[0]: Icon[1]"
                class="radioImg"
              >
          </van-radio>
        </van-radio-group>
        </div>
        <!-- 确定 取消 -->
        <div class="confirm-cancel">
              <div class="button-flex-color flex-border-button">
                   <div class="button-flex-item" @click="addCL">取消</div>
              </div>
              <div  class="button-flex-color">
                    <div class="button-flex-item button-active"  @click="addCF">确定</div>
              </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="show" position="bottom" :overlay="true">
      <van-picker
        show-toolbar
        title=""
        :columns="columns"
        @cancel="onCancel"
        @confirm="onConfirm"
         value-key="name"
        class="van-picker-li"
      />
    </van-popup>
    <!-- 区号筛选 -->
    <van-popup v-model="showUser" position="bottom" :overlay="true">
      <van-picker
        show-toolbar
        title=""
        :columns="columnsCode"
        @cancel="onCancelCode"
        @confirm="onConfirmCode"
         value-key="name"
        class="van-picker-li"
      />
    </van-popup>
    <van-actionsheet
      v-model="Kshow"
      :actions="columnK"
      cancel-text="取消"
      @select="onSelectK"
      @cancel="onCancelK"
    />
    <van-popup v-model="filtersShow" position="right" :overlay="false"  style="width:100%" >
              <Filters/>
    </van-popup>
    <!-- 分派按钮 -->
    <div class="toAssign" v-if=" this.$store.state.show==2" :style="{bottom:this.$store.state.show==2?'0rem':'1rem'}">
      <div class="toAssign-button" @click="toAssign">分派</div>
    </div>
    <!-- 分页数据计算 -->
    <div class="loaded"  :style="{bottom:this.$store.state.show==2?'1.2rem':'0rem'}" >已加载 {{this.list.length}}/{{totalRow}}</div>
  </Page>
</template>




<script>

import Filters  from  './filter';
import {Dialog} from "vant";


export default {
  name: "client-Page",
  data() {
    return {
      title: "客户信息",
      columns: ["全部客户", "我的客户"],    // 筛选客户
      columnsCode:['+86'],                // 筛选区号
      totalRow:0,                         // 总条数
      inputContent:"",                    // 输入框
      list:[],
      filtrateList: [
        {
          name: "VIP等级",
          edit: false,
          orderCol : 'vipLevel',
          status: 0 //0不排序 1升序 -1降序
        },
        {
          name: "预计购买日期",
          edit: false,
          orderCol : 'planDate',
          status: 0
        },
        {
          name: "最近购买日期",
          edit: false,
          orderCol : 'buyDate',
          status: 0
        },
        {
          name: "跟进日期",
          edit: false,
          orderCol : 'followDate',
          status: 0
        }
      ],
      show: false,
      loading: false,
      finished: false,
      addClient: false, //新增客户
      genderRadio:'1',   // 性别筛选
      filtersShow:false, // 高级筛选
      /**********  查询字段  **********/
      pageNumber:1,
      pageSize:10,
      queryParam:"",
      sortCol:"", // 排序字段
      sortType:"", // 升序-降序
      courseStartDate:"",
      courseEndDate:"",
      courseId:"",
      registerStartDate:"",
      registerEndDate:"",
      campaignId:"",
      intention:"",
      purchaseStartDate:"",
      purchaseEndDate:"",
      custName:"",
      mobile:"",
      birthdayStartDate:"",
      birthdayEndDate:"",
      createdStartDate:"",
      createdEndDate:"",
      vipLevel:"",
      member:"",
      custType:"",
      shootingType:"",
      hobby:"",
      weddingStartDate:"",
      weddingEndDate:"",
      selectDeptId:"",
      selectSalesId:"",
      queryFlag:0,        //客户类型 全部客户 我的客户
      queryFlagText:"全部客户",
      //页面进入查询参数
      pageQueryParams : {},
      salesChooseShow : false,
      PageShow:false,       // false 默认客户列表  true  待分配列表
      pageListShow:true,   //加载判断
      checked:false,
      custList:[],        // 分派列表
      dispatchUserId:"",  // 分派销售用户ID
      showUser:false,     // 销售顾问展示
      addClientObj:{
       code:"+86",      //区号
       phone:"",        //手机号码
       name:"",         //姓名
       sex:'1',         //性别
       codeValue:"86",   //默认code
      },       // 客户新增信息
      Kshow:false,  //快捷入口
      columnK:[],   //快捷入口列表（动态生成）
      columnC:[
        {
          name:"全部客户",
          id:0,
        },
        {
          name:"我的客户",
          id:1,
        }
      ],
      Kid:"",  //快捷入口ID
      showCC:false, //来自学院信息
      U_AreaCode:[],//区号
      showCodes:1,  // 1客户类型  2 区号
      IdCode:"",    // 菜单ID
      Icon:[ require('@/assets/Sc.png'),require('@/assets/Sn.png')],
      hasAddAuth : true, //是否有添加的权限
      hasLeadCreated: false, // 意向记录新增权限
      hasPRCreated: false, // 购买记录新增权限
      hasFollowCreated: false, // 跟进记录新增权限
    };
  },
  methods: {
    /**
     * 分页排序
     */
    order4Page : function (orderItem) {
      this.clearOrderOption(orderItem);
      if(!orderItem){
        return ;
      }
      var orderStatus = orderItem.status;

      if(orderStatus == 0){
        orderItem.status = 1;
      }
      orderItem.status = -orderItem.status;
      orderStatus = orderItem.status;
      this.loading = false;
      this.list=null;
      this.pageNumber=1;
      this.finished = false;
      this.sortCol=orderItem.orderCol;
      this.sortType=(orderStatus == "1" ? "asc" : "desc")
      this.getClientlist(1,1);
    },

    /**
     *  打开个人信息页接口
     *
     * */
    openUserProfile(userExId){
      this.$wxuserUtil.openUserProfile(userExId)
    },
    openTaskUrl(userExId){
        window.location.href = `${this.APPCFG.taskBaseUrl}?userld=${this.$wxuserUtil.getUserId()}&externalUserld=${userExId}`;
    },
    /**
     * 清除排序条件
     */
    clearOrderOption : function (targetOrderItem) {
      targetOrderItem = targetOrderItem || {};
       var orderItemList = this.filtrateList;
       for(var i=0;i<orderItemList.length;i++){
         var orderItem = orderItemList[i];
         if(orderItem.name == targetOrderItem.name){
           continue;
         }

         orderItem.status = 0;
       }
    },

    /**
     *   客户筛选
     */
    onConfirm(value, index) {
      console.log("区号",value)
      if(this.showCodes==1){
          value.id==0?this.queryFlagText="全部客户":this.queryFlagText="我的客户";
          this.queryFlag=value.id;
          this.loading = false;
          this.finished = false;
          this.getClientlist(1,1);
          this.show=false;
      }else{
         this.addClientObj['codeValue']=value.value;
         this.addClientObj['code']=value.name;
         this.show=false;
      }

    },
    onCancel() {
       this.show = false;
    },
    /**
     *
     *  新增客户
     *
     */
    addCL(){
      this.addClient=false
      this.addClientObj={
       code:"+86",     //区号
       phone:"",       //手机号码
       name:"",        //姓名
       sex:'1',        //性别
       codeValue:'86',
      }
    },
    addCF(){
      let data={
        salesId:this.$wxuserUtil.getUserId(),
        mobile:this.addClientObj['phone'],
        custName:this.addClientObj['name'],
        gender:this.addClientObj.sex==1?0:1,
        areaCode:this.addClientObj['codeValue']
      }
      if(this.addClientObj.phone==""){
         this.$title("请输入手机号码");
         return;
      }
      if(this.addClientObj.name==""){
         this.$title("请输入客户姓名");
         return;
      }
      console.log("新增客户数据",data);
      this.saveCustAdd(data)
    },
    //手机号验证
    phoneCS(val){
           console.log("失去焦点",val)
           let phone="";
           if(this.addClientObj.codeValue=="86"){
              phone=val
           }else{
              phone=val
           }
           this.getCustValidatorMobile(phone)
    },
    /**
     *   销售顾问筛选
     */
    onCancelCode(){
      this.showUser=false
    },
    onConfirmCode(val){
     this.showUser=false;
      if(val.value){
            if(this.getSelectAll().length>0){
                 this.dispatchUserId=val.value;
                 this.custList=this.getSelectAll();
                 this.saveCustDispatch(val.value,this.getSelectAll());
            }else{
             this.$title("请选择指派的客户");
              return;
            }
      }
    },
    /**
     *
     * 获取所有选中的客户
     *
     */
    getSelectAll(){
       let data      =   this.list;
       let $data     =[];
       for(let i=0;i<data.length;i++){
          if(data[i]['edit']==true){
             $data.push(data[i]['custId'])
          }
       }
       return $data;
    },
    pickerClient(ID) {
       this.showCodes=ID;
       switch(ID){
          case 1   :  this.columns   =  this.columnC;break
          case 2   :  this.columns   =  this.U_AreaCode;break
       }
       this.show = true;
    },
    onLoad() {
      setTimeout(() => {
        if(this.pageListShow==true){
        this.pageNumber= parseInt(this.pageNumber+1)
        this.getClientlist(2,this.pageNumber)
        this.loading = false;
        }
      }, 500);
    },
    /**
     *   新增客户  触发弹框
     */
    addClients() {
      this.addClient = true;
    },
    home(){
      this.$refs.inputText.blur();
      this.$router.push({ path: "/"});  },
    /**
     *  高级搜索
     */
    searchFilter(){
       this.$refs.inputText.blur();
       this.$router.push({ path: "/Filter", query: {type:1} });
      },
    /**
     *
     *  查询客户列表
     *  @param {String}  salesId       销售用户ID
     *  @param {String}  queryParam    列表查询条件，手机号或者客户姓名 高级搜索该字段不需要传
     *  @param {Number}  pageNumber    分页页码
     *  @param {Number}  pageSize      分页每页条数
     *  @param {String}  sortCol
     *  排序字段   多个排序可以以半角英文逗号分隔
        vipLevel      ：    VIP等级
        planDate,     ：   预计购买时间
        buyDate,      ：   购买日期
        followDate    ：   跟进日期
        @param {String}  sortType         排序类型( asc : 升序, desc : 降序)
        @param {String}  courseStartDate  课程时间段  开始时间
        @param {String}  courseEndDate    课程时间段  结束时间
        @param {String}  courseId         课程ID
        @param {String}  registerStartDate   参加活动 开始时间
        @param {String}  registerEndDate     参加活动 结束时间
        @param {String}  campaignId          活动ID
        @param {String}  intention           购买意向
        @param {String}  purchaseStartDate   产品购买时间 开始时间
        @param {String}  purchaseEndDate     产品购买时间 结束时间
        @param {String}  custName            客户姓名
        @param {String}  mobile              手机号码
        @param {String}  birthdayStartDate   客户生日 开始时间
        @param {String}  birthdayEndDate     客户生日 结束时间
        @param {String}  vipLevel            VIP 等级
        @param {String}  member              徕卡会员
        @param {String}  custType            客户类型
        @param {String}  shootingType        摄影主题
        @param {String}  hobby               兴趣爱好
        @param {String}  weddingStartDate    结婚纪念日 开始时间
        @param {String}  weddingEndDate      结婚纪念日 结束时间
        @param {String}  selectDeptId        查询部门
        @param {String}  selectSalesId       查询销售用户
     *
     **/
    getClientlist(ID,Page,queryParams){
      this.pageListShow=false;
      Page = Page || 1;
          let data=this.$.extend(true,{},this.pageQueryParams ||{});
              data['salesId']=this.$wxuserUtil.getUserId();
              data['queryParam']=this.queryParam;
              data['pageNumber']=Page;
              data['pageSize']=this.pageSize;
              data['sortCol']=this.sortCol;
              data['sortType']=this.sortType;

              data['queryFlag']=this.queryFlag;
          let Response = this.$api.getClientlist(data);
              let $data  =  Response.data.list;
              for(let i=0;i<$data.length;i++){
                  $data[i]['vipLevel']=$data[i]['vipLevel']?$data[i]['vipLevel']/10:0;
                  $data[i]['edit']=false;
              }
              if(ID==1){
                 this.list=Response.data.list || [];
                 if(Response.data.list.length==0||!Response.data.list){
                    this.finished = true;
                   }else{
                     this.finished=false;
                   }
                   this.totalRow=Response.data.totalRow;
                   this.pageListShow=true;
              }
              if(ID==2){
                 if(Response.data.list.length==0||this.list.length>=Response.data.totalRow){
                  this.finished = true;
                 }else{
                  this.finished=false;
                  this.list=this.list.concat(Response.data.list||[])
                 }
                 this.pageListShow=true;
              }
        this.getSalesLists();
        this.getQueryByTcode();
    },
    /**
     *   客户详情
     **/
    toClientDetail(ID){
      if(ID){
        this.$refs.inputText.blur();
        this.$router.push({ path: "/ClientDetails", query: {custId:ID,showCC:this.showCC,IdCode:this.IdCode} })
      }
    },
    /**
     *
     *  获取code
     *  @param {String} tcode
     *
     */
    getQueryByTcode(){
          this.$api.getQueryByTcode({tcode:'U_AreaCode'}).then(Response=>{
              console.log("获取区号",Response)
              if(Response.success){
                  this.U_AreaCode=Response.data;
              }else{
                this.$title(Response.msg);
              }
          })
    },
    /**
     *
     *  输入框回车事件
     *
     **/
    submitInput(val){
      this.list=[]
      this.pageNumber=1;
      this.$refs.inputText.blur();
      if(val==""){
      this.clearInputs()
      }else{
      this.loading = false;
      this.finished = false;
      this.getClientlist(1,1)
      this.$refs.scrollView.scrollTop=0;
      }
    },
    searchInput(val){
      this.pageQueryParams = {};
      this.$refs.inputText.blur();
      this.list=[]
      this.pageNumber=1;
      if(val==""){
      this.clearInputs()
            console.log("获取输入框值",val)
      }else{
        this.list=[]
        this.pageNumber=1;
        this.loading = false;
        this.finished = false;
        this.getClientlist(1,1)
      }
    },
    clearInputs(){
      /**
       *
       *  清空高级搜索
       *  清空筛选
       *  清空页面值
       *
       **/
       this.pageNumber=1;
       this.pageSize=10;
       this.queryParam="";
       this.sortCol=""; // 排序字段
       this.sortType=""; // 升序-降序
       this.courseStartDate="";
       this.courseEndDate="";
       this.courseId="";
       this.registerStartDate="";
       this.registerEndDate="";
       this.campaignId="";
       this.intention="";
       this.purchaseStartDate="";
       this.purchaseEndDate="";
       this.custName="";
       this.mobile="";
       this.birthdayStartDate="";
       this.birthdayEndDate="";
       this.createdStartDate="";
       this.createdEndDate="";
       this.vipLevel="";
       this.member="";
       this.custType="";
       this.shootingType="";
       this.hobby="";
       this.weddingStartDate="";
       this.weddingEndDate="";
       this.selectDeptId="";
       this.selectSalesId="";
       console.log("开始生日日期",this.birthdayStartDate)
       for(let o  in  this.filtrateList){
         this.filtrateList[o]['status']=0;
       }
       this.getClientlist(1,1)
    },

    /**
     * 选择待分派的销售用户
     */
    toAssign() {
      if(this.getSelectAll().length>0){
              this.showUser = true;
      }else{
             this.$title("请选择指派的客户");
      }

    },
    /**
     *
     *  销售顾问
     *
     */
    getSalesLists(){
      this.$api.getSalesLists(
        {
        salesId:  this.$wxuserUtil.getUserId(),
        deptId: this.$wxuserUtil.getDeptId()
        }
      ).then(Response=>{
              let data  =  Response.data || [];
              for(let i=0;i<data.length;i++){
                  data[i]['value']=data[i]['userId'];
                  data[i]['name']=data[i]['userName'];
              }
              if(Response.success){
                    this.columnsCode =data;
              }
      })
    },
    /**
     *
     *
     *  全选  取消全选
     *
     */
    allCheckedNo(ID){
        let $data   =   this.list;
        for(let i=0;i<$data.length;i++){
            if(ID==1){
                $data[i]['edit']=true;
            }else{
                $data[i]['edit']=false;
            }
        }
        this.list=$data;
    },
   clickCheck(val){
     if(val==!true){
       this.allCheckedNo(1)
     }else{
       this.allCheckedNo(0)
     }
   },
   /**
    *
    *  客户分派
    *
    *
    */
   saveCustDispatch(ID,list){
     this.$api.saveCustDispatch({
       salesId:this.$wxuserUtil.getUserId(),
       dispatchUserId:ID,
       custList:JSON.stringify(list)
     }).then(Response=>{
            if(Response.success){
                this.$title(Response.msg)
                this.dispatchUserId="";
                this.custList=[];
                this.getClientlist(1,this.pageNumber);
            }else{
                this.$title(Response.msg)
            }
     })
   },
   /**
    *
    * 新增客户
    *
    */
   saveCustAdd(data){
     this.$api.saveCustAdd(data).then(Response=>{
          if(Response.success){
            this.$title("新增客户成功");
            setTimeout(() => {
              this.$router.push({ path: "/ClientDetails", query: {custId:Response.data.custId,showCC:this.showCC,IdCode:this.IdCode} })
            }, 500);
          }else{
            this.$title(Response.msg);
          }
     })
   },
   /**
    *
    * 手机号码验证
    *
    */
   getCustValidatorMobile(Phone){
          this.$refs.inputText.blur();
          this.$api.getCustValidatorMobile({
            mobile:Phone,
            salesId:this.$wxuserUtil.getUserId(),
          }).then(Response=>{
          if(Response.data){
          if(Response.data.custId){
            this.$dialog.confirm({
            title: '提示',
            message: `客户已存在`,
            // message: `客户已存在-${Response.data.deptName}门店`,
            confirmButtonText:"查看"
            }).then(() => {

            this.$router.push({ path: "/ClientDetails", query: {custId:Response.data.custId,IdCode:this.IdCode} })
            }).catch(() => {
            this.addClient=false;
            this.addCL();
            });

          }
          }
     })
   },
   /**
    *
    *  快捷入口
    *
    */
  shortcut(val){
      this.Kshow=true;
      this.Kid=val
  },
  onSelectK(val){
      if(this.Kid){
       this.$router.push({ path: "/ClientDetails",
          query: {custId:this.Kid,showID:val.id,IdCode:this.IdCode,value:val.value} ,

         })
      }
  },
  onCancelK(val){
      this.Kshow=false;
  },

  /**
   * 根据权限生成快捷入口列表
   */
  generateShortcutMenu() {
    this.columnK = [];

    // 新增意向记录
    if (this.hasLeadCreated) {
      this.columnK.push({
        name: '新增意向记录',
        id: 1,
      });
    }

    // 新增购买记录
    if (this.hasPRCreated) {
      this.columnK.push({
        name: '新增购买记录',
        id: 2,
      });
    }

    // 新增跟进记录
    if (this.hasFollowCreated) {
      this.columnK.push({
        name: '新增跟进记录',
        id: 3,
      });
    }

    // 扫码新增购买记录
    if (this.hasPRCreated) {
      this.columnK.push({
        name: '扫码新增购买记录',
        id: 2,
        value: 'qrcode'
      });
    }
  },
  },
  mounted() {
      // 检查各项权限
      this.hasAddAuth = this.$wxuserUtil.hasFunAuthByRouteInst(this.$route,this.$funcKey.BasicCreated);
      this.hasLeadCreated = this.$wxuserUtil.hasFunAuthByRouteInst(this.$route, this.$funcKey.LeadCreated);
      this.hasPRCreated = this.$wxuserUtil.hasFunAuthByRouteInst(this.$route, this.$funcKey.PRCreated);
      this.hasFollowCreated = this.$wxuserUtil.hasFunAuthByRouteInst(this.$route, this.$funcKey.FollowCreated);

      // 根据权限生成快捷入口列表
      this.generateShortcutMenu();
      this.$refs.scrollView.style.height=localStorage.getItem('height')-100+'px';
      let q = this.$route.query.q;
      let queryParams = {};

      if(q){
        queryParams = JSON.parse(this.$Base64.decode(q)) || {};
        console.log("获取路由传参",queryParams)
        for(let i  in queryParams){
           this[i]=queryParams[i]
        }

        this.pageQueryParams = queryParams;
        if( this.$store.state.show==1||localStorage.getItem('show')==1){
        document.title="学员信息列表";
         this.PageShow=false;
         this.showCC=true;
        }else
        if( this.$store.state.show==2||localStorage.getItem('show')==2){
        document.title="待分配客户列表";
        this.PageShow=true;
        this.showCC=false;
        }else{
        this.PageShow=false;
        this.showCC=false;
        document.title="客户信息列表";
        }
      }
      this.IdCode=this.$route.query.IdCode;
      this.$wxuserUtil.initWxSdk()
      /**初始化页面数据 */
      this.getClientlist(1,this.pageNumber);
  },
  created() {},
  watch: {
  },
  components:{
    Filters,
  },

};
</script>
<style lang="less" scoped="true" src="~p/pageView-client.less"></style>



// WEBPACK FOOTER //
// src/components/client/client.vue